import * as yup from "yup";

export const normalCommissionSchema = yup.object().shape({
  employee_id: yup.string().required("Funcionário obrigatório"),
  startDate: yup.date().required("Data inicial obrigatória"),
  endDate: yup.date().required("Data final obrigatória"),
  payment_method_id: yup
    .number()
    .transform((value, originalValue) =>
      originalValue === "" || originalValue == null
        ? null
        : Number(originalValue),
    )
    .nullable()
    .when("$isSettlement", {
      is: true,
      then: (schema) => schema.required("Método de pagamento é obrigatório"),
      otherwise: (schema) => schema.nullable().notRequired(),
    }),

  paid_at: yup
    .date()
    .transform((value, originalValue) =>
      originalValue === "" || originalValue == null
        ? null
        : new Date(originalValue),
    )
    .nullable()
    .when("$isSettlement", {
      is: true,
      then: (schema) => schema.required("Data de pagamento é obrigatória"),
      otherwise: (schema) => schema.nullable().notRequired(),
    }),
});
